const state = {
  latitude: 0,
  longitude: 0
}

const getters = {
  position: (state) => {
    return {
      lat: state.latitude,
      lng: state.longitude
    }
  },

  point: (state) => {
    return {
      latitude: state.latitude,
      longitude: state.longitude
    }
  }
}

const mutations = {
  setPosition (state, value) {
    state.latitude = parseFloat(value.latitude)
    state.longitude = parseFloat(value.longitude)
  }
}

const actions = {
  setPosition ({ commit }) {
    return new Promise((resolve) => {
      const options = {
        maximumAge: 0,
        enableHighAccuracy: true
      }
      navigator.geolocation.getCurrentPosition((position) => {
        commit('setPosition', position.coords)
        resolve()
      }, (error) => {
        if (error.message == 'User denied Geolocation') {
          alert("Please enable your browser location. \nブラウザの位置情報を有効化してください")
        } else {
          console.log(error)
        }
      }, options)
    })
  },

  keepUpdate ({ dispatch, rootState }) {
    window.setInterval(() => {
      if (rootState.event.playing) {
        dispatch('setPosition')
      }
    }, 3000)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
